import {
    get,
    post
} from '@/utils/request'

const SERVICE_URL = '/quotation-service/v1'

export function getAuditList(params) {
    return post(SERVICE_URL + '/rfqAudit/listRfqAudit', params)
}
export function deleteAudit(params, pathParam) {
    return post(SERVICE_URL + '/rfqAuditTotal/deleteAudit', params, pathParam)
}
export function queryById(params, pathParam) {
    return get(SERVICE_URL + '/rfqAuditTotal/getById', params, pathParam)
}
export function auditList(params) {
    return post(SERVICE_URL + '/partAuditView/list', params)
}
export function createAudit(params) {
    return post(SERVICE_URL + '/rfqAuditTotal/insertAudit', params)
}
export function editAudit(params) {
    return post(SERVICE_URL + '/rfqAuditTotal/updateAudit', params)
}
export function getSupplierList(params) {
    return post(SERVICE_URL + '/rfqAuditTotal/getSupplierList', params)
}



export function getAuditSupplier(params) {
    return post(SERVICE_URL + '/rfqAuditSupplier/getAuditSupplier', params)
}

export function getZBSupplierCountByRfqId(params, pathParam) {
    return get(SERVICE_URL + '/rfqAuditSupplier/getZBSupplierCountByRfq', params, pathParam)
}

export function getAuditById(params, pathParam) {
    return get(SERVICE_URL + '/rfqAudit/getById', params, pathParam)
}


export function generateAudit(params) {
    return post(SERVICE_URL + '/rfqAudit/generate', params)
}

//审批
export function approve(params) {
    return post(SERVICE_URL + '/rfqAudit/approve', params)
}

//发送定厂通知
export function resultNotice(params) {
    return post(SERVICE_URL + '/rfqAudit/resultNotice', params)
}
//拟定价格协议
export function createPriceAgreement(params) {
    return post(SERVICE_URL + '/rfqAudit/createPriceAgreement', params)
}
//定点议价
export function updateSpotPrice(params) {
    return post(SERVICE_URL + '/rfqAudit/updateSpotPrice', params)
}

export function exportAudit(params) {
    return post(SERVICE_URL + '/rfqAudit/export', params)
}

export function exportNewAudit(params) {
    return post(SERVICE_URL + '/rfqAudit/exportNew', params)
}

export function getPayType(params) {
    return post(SERVICE_URL + '/rfqAudit/getPayType', params)
}

export function setPayType(params) {
    return post(SERVICE_URL + '/rfqAudit/setPayType', params)
}
